const initialState = {
  days: 30
}

// eslint-disable-next-line default-param-last
const globalFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GLOBAL_FILTERS_SET':
      return {
        ...state,
        ...action.filters
      }
    default:
      return state
  }
}

export default globalFiltersReducer
